import { DOCUMENT } from '@angular/common';
import {
  Component,
  Inject,
  ElementRef,
  OnInit,
  Renderer2,
  HostListener,
  AfterViewInit,
  ViewEncapsulation
} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ConfigService } from 'src/app/config/config.service';
import { AuthService } from 'src/app/core/service/auth.service';
import { RightSidebarService } from 'src/app/core/service/rightsidebar.service';
import { LanguageService } from 'src/app/core/service/language.service';

import { TranslateService } from '@ngx-translate/core';
import * as $ from 'jquery';
import { environment } from 'src/environments/environment';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { BaseService } from 'src/app/core/service/base.service';
import { HomedataService } from 'src/app/core/service/homedata.service';
import { BehaviorSubject, Subscription } from 'rxjs';
import { User } from 'src/app/core/models/user';


const document: any = window.document;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class HeaderComponent implements AfterViewInit, OnInit {
  public config: any = {};
  isNavbarCollapsed = true;
  isNavbarShow: boolean;
  flagvalue;
  countryName;
  langStoreValue: string;
  defaultFlag: string;
  numberOfNotifications = 0;
  mySchools: any;
  mySchoolslength: any;
  sId = localStorage.getItem('schoolId');
  schoolId: any;
  defaultSchool: any;
  defaultSchoolId: any;
  DSAfterChanging; any;
  public sidebarItems: any[];

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    public elementRef: ElementRef,
    private dataService: RightSidebarService,
    private configService: ConfigService,
    public authService: AuthService,
    // private taskRecipientService: TaskRecipientService,
    private router: Router,
    private route: ActivatedRoute,
    public languageService: LanguageService,
    private translate: TranslateService,
    private http: HttpClient,
    public baseService: BaseService,
    public homedataService: HomedataService,
    private galleryService: HomedataService,
    private usersService: HomedataService,
  ) {
    translate.setDefaultLang('ar');

    // this.authService.currentUserSubject = new BehaviorSubject<User>(
    //   JSON.parse(localStorage.getItem('user'))
    // );
    this.authService.user = JSON.parse(localStorage.getItem('user'));
    // console.log("idAfter",this.authService.user.id);
    //  console.log("currentUserAuth",this.authService.user.id)


  }
  listLang = [
    { text: 'English', flag: 'assets/images/flags/us.jpg', lang: 'en' },
    { text: 'Spanish', flag: 'assets/images/flags/spain.jpg', lang: 'es' },
    { text: 'German', flag: 'assets/images/flags/germany.jpg', lang: 'de' }
  ];
  notifications: any = [];
  subscription: Subscription | null = null;
  subscription2: Subscription | null = null;
  subscription3: Subscription | null = null;

  // apiUrl = 'https://' + environment.url + '/';
  ngOnInit() {
    this.loadData();

    // this.config = this.configService.configData;

    // this.langStoreValue = localStorage.getItem('lang');
    // const val = this.listLang.filter((x) => x.lang === this.langStoreValue);
    // this.countryName = val.map((element) => element.text);
    // if (val.length === 0) {
    //   if (this.flagvalue === undefined) {
    //     this.defaultFlag = 'assets/images/flags/us.jpg';
    //   }
    // } else {
    //   this.flagvalue = val.map((element) => element.flag);
    // }
    document.getElementById('language').innerText = (localStorage.getItem('dir') === 'rtl' ? 'English' : 'العربية');
  }
  loadData() {
    // this.taskRecipientService.getsNotifications().subscribe(data => {
    //   this.notifications = data.returnData
    //   this.numberOfNotifications = this.notifications.length
    // }
    const token = localStorage.getItem('token');
    const header = new HttpHeaders().set('x-access-token', token);
    this.http.get<any>(this.baseService.apiUrl + '/school/', { headers: header })
      // .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(data => {
        this.baseService.blockStop();
        //  
        localStorage.setItem('schools', JSON.stringify(data.data));
        // //  localStorage.setItem('routeMenuItems', JSON.stringify(data.data));
        // this.mySchools = JSON.parse(localStorage.getItem('schools'));
        this.mySchools = data.data;
        // console.log("mySchools",this.mySchools)
        for (let i = 0; i < this.mySchools.length; i++) {
          if (this.mySchools[i].isDefault == '1') {
            // this.defaultSchool=this.mySchools[i].name;
            this.defaultSchool = this.mySchools[i].name;
            this.defaultSchoolId = this.mySchools[i].id;
          }
        }
        this.baseService.schoolId = this.defaultSchoolId;
      });



    // )
  }

  ViewRequest(url) {

    $('.dropdown-notifications').removeClass('show');
    $('.dropdown-menu').removeClass('show');
    $('.collapse').removeClass('show').attr('ng-reflect-collapsed', 'true');
    $('.dropdown-toggle').attr('aria-expanded', 'false');

    this.router.navigate([url]);
  }

  closeDropDown(url) {
    $('.dropdown').removeClass('show');
    $('.dropdown-menu').removeClass('show');
    $('.collapse').removeClass('show').attr('ng-reflect-collapsed', 'true');
    $('.dropdown-toggle').attr('aria-expanded', 'false');

    this.router.navigate([url]);
  }

  changeLang() {
    const lang = this.languageService.getLanguage();
    if (lang === 'English') {
      this.languageService.setLayout('ltr', 'rtl');
      this.languageService.setLanguage('en');
      // document.getElementById('language').innerText = 'العربية';
    } else if (lang === 'العربية') {
      this.languageService.setLayout('rtl', 'ltr');
      this.languageService.setLanguage('ar');
      // document.getElementById('language').innerText = 'English';
    }
    parent.document.location.reload();
  }

  ngAfterViewInit() {
    // set theme on startup
    // if (localStorage.getItem('theme')) {
    //   this.renderer.removeClass(this.document.body, this.config.layout.variant);
    //   this.renderer.addClass(this.document.body, localStorage.getItem('theme'));
    // } else {
    //   this.renderer.addClass(this.document.body, this.config.layout.variant);
    // }

    // if (localStorage.getItem('menuOption')) {
    //   this.renderer.addClass(
    //     this.document.body,
    //     localStorage.getItem('menuOption')
    //   );
    // } else {
    //   this.renderer.addClass(
    //     this.document.body,
    //     'menu_' + this.config.layout.sidebar.backgroundColor
    //   );
    // }

    // if (localStorage.getItem('choose_logoheader')) {
    //   this.renderer.addClass(
    //     this.document.body,
    //     localStorage.getItem('choose_logoheader')
    //   );
    // } else {
    //   this.renderer.addClass(
    //     this.document.body,
    //     'logo-' + this.config.layout.logo_bg_color
    //   );
    // }

    // if (localStorage.getItem('sidebar_status')) {
    //   if (localStorage.getItem('sidebar_status') === 'close') {
    //     this.renderer.addClass(this.document.body, 'side-closed');
    //     this.renderer.addClass(this.document.body, 'submenu-closed');
    //   } else {
    //     this.renderer.removeClass(this.document.body, 'side-closed');
    //     this.renderer.removeClass(this.document.body, 'submenu-closed');
    //   }
    // } else {
    //   if (this.config.layout.sidebar.collapsed === true) {
    //     this.renderer.addClass(this.document.body, 'side-closed');
    //     this.renderer.addClass(this.document.body, 'submenu-closed');
    //   }
    // }
  }

  callFullscreen() {
    if (
      !document.fullscreenElement &&
      !document.mozFullScreenElement &&
      !document.webkitFullscreenElement &&
      !document.msFullscreenElement
    ) {
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.msRequestFullscreen) {
        document.documentElement.msRequestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen();
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    }
  }

  setLanguage(text: string, lang: string, flag: string) {
    this.countryName = text;
    this.flagvalue = flag;
    this.langStoreValue = lang;
    // this.languageService.setLanguage(lang);
  }

  mobileMenuSidebarOpen(event: any, className: string) {
    const hasClass = event.target.classList.contains(className);
    if (hasClass) {
      this.renderer.removeClass(this.document.body, className);
    } else {
      this.renderer.addClass(this.document.body, className);
    }


  }

  callSidemenuCollapse() {
    const hasClass = this.document.body.classList.contains('side-closed');
    const bigLogo = this.document.getElementById('big-Logo');
    const smallLogo = this.document.getElementById('small-Logo');
    if (hasClass) {
      this.renderer.removeClass(this.document.body, 'side-closed');
      this.renderer.removeClass(this.document.body, 'submenu-closed');


      this.renderer.removeClass(bigLogo, 'hide-logo');
      this.renderer.removeClass(smallLogo, 'show-logo');
      this.renderer.addClass(bigLogo, 'show-logo');
      this.renderer.addClass(smallLogo, 'hide-logo');
    } else {
      this.renderer.addClass(this.document.body, 'side-closed');
      this.renderer.addClass(this.document.body, 'submenu-closed');
      this.renderer.removeClass(bigLogo, 'show-logo');
      this.renderer.removeClass(smallLogo, 'hide-logo');
      this.renderer.addClass(bigLogo, 'hide-logo');
      this.renderer.addClass(smallLogo, 'show-logo');
    }
  }

  public toggleRightSidebar(): void {
    this.dataService.changeMsg(
      (this.dataService.currentStatus._isScalar = !this.dataService
        .currentStatus._isScalar)
    );
  }

  logout() {
    this.authService.logout().subscribe((res) => {
      if (!res.success) {
        this.router.navigate(['/authentication/signin']);
      }
    });
  }

  show(schoolId) {
    this.baseService.blockStart();
    this.baseService.schoolId = schoolId;
    // this.baseService.blockStop();
    $('.dropdown').removeClass('show');
    $('.dropdown-menu').removeClass('show');
    $('.collapse').removeClass('show').attr('ng-reflect-collapsed', 'true');
    $('.dropdown-toggle').attr('aria-expanded', 'false');

    // localStorage.setItem('schoolId', schoolId);


    // this.closeDropDown('/page/schoolRoles/view/'+schoolId+'')

    // this.schoolId=schoolId;
    // console.log(this.mySchools)
    //  this.closeDropDown('/page/schoolRoles/view/'+schoolId+'')
    const token = localStorage.getItem('token');
    const header = new HttpHeaders().set('x-access-token', token);
    this.http.post<any>(this.baseService.apiUrl + 'school/set_default', { school: schoolId }, { headers: header })
      .subscribe(data => {

        localStorage.setItem('schools', JSON.stringify(data.data));
        this.mySchools = data.data;

        for (let i = 0; i < this.mySchools.length; i++) {
          if (this.mySchools[i].isDefault == '1') {
            // this.defaultSchool=this.mySchools[i].name;
            this.defaultSchool = this.mySchools[i].name;
            this.defaultSchoolId = this.mySchools[i].id;
          }
        }
        this.baseService.schoolId = this.defaultSchoolId;
        console.log('school Id', this.baseService.schoolId);
        this.subscription = this.homedataService.getAnnouncements(this.baseService.schoolId).subscribe(
          (response: any) => {
            this.baseService.announ = response.data;
            console.log(response.data);
          },
          (err) => { console.log(err); }
        );


        this.subscription2 = this.galleryService.getGalleries(this.baseService.schoolId).subscribe(
          (response: any) => {
            this.baseService.gallery = response.data;
          },
          (err) => { console.log(err); }
        );

        this.subscription3 = this.usersService.getUsersCount(this.baseService.schoolId).subscribe(
          (response: any) => {
            this.baseService.users = response.users;
            this.baseService.viewteachers = this.baseService.users.filter(o => o.access_level == 'teacher');
            this.baseService.viewStudents = this.baseService.users.filter(o => o.access_level == 'students');
            this.baseService.viewDrivers = this.baseService.users.filter(o => o.access_level == 'drivers');

          },
          (err) => { console.log(err); }
        );
        // console.log(this.route)
        // console.log(this.route.snapshot.data)
        // console.log(this.router)

        // console.log(this.router.url)
        this.closeDropDown('/page/home');
        console.log(schoolId);


        // const hasClass = this.document.body.classList.contains('side-closed');
        // const bigLogo = this.document.getElementById('big-Logo')
        // const smallLogo = this.document.getElementById('small-Logo')
        // if (!hasClass) {
        //   this.renderer.addClass(this.document.body, 'side-closed');
        //   this.renderer.addClass(this.document.body, 'submenu-closed');
        //   this.renderer.removeClass(bigLogo, 'show-logo');
        //   this.renderer.removeClass(smallLogo, 'hide-logo');
        //   this.renderer.addClass(bigLogo, 'hide-logo');
        //   this.renderer.addClass(smallLogo, 'show-logo');
        // }

      });


    this.http.get<any>(this.baseService.apiUrl + 'getMenusChildren/' + schoolId, { headers: header })
      .subscribe(data => {
        this.baseService.blockStop();
         
        this.baseService.sidebarItems = data.data;
        // localStorage.setItem('routeMenuItems', JSON.stringify(data.data));
      },
        error => {
          this.baseService.blockStop();
          console.log(error);
        });


  }

  //   setLinkActive()
  //   {
  //     console.log(this.sId)
  //     console.log(this.schoolId)
  //     if(this.sId==this.schoolId)
  //   {

  //     //  document.getElementById("item").style.backgroundColor = "blue";

  //   }
  // }
}
